import React from "react";
import ReactDOMClient from "react-dom/client";
import { KrititLandingPage } from "./screens/KrititLandingPage";

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);
root.render(<KrititLandingPage />);
